class HotNot {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.hotNot')

    if (!this.section)
      return

    this.wrapper  = this.section.querySelector('.hotNot__wrapper')
    this.buttons  = this.wrapper.querySelectorAll('.hotNot__vote')
    this.percents = this.wrapper.querySelectorAll('.hotNot__votePercent')
    this.results  = this.wrapper.querySelectorAll('.hotNot__result')
    this.count    = this.wrapper.querySelector('.hotNot__descValue')

    return true

  }

  setEvents() {

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.saveVote(index)

      })

    })

  }

  saveVote(index) {

    var id = $("#hnt_id").val();
	  var that = this;
	  var vote = 'hot';
	  if (index == 1) {
		  vote = 'not';
	  }

	  $.getJSON("/hotOrNotVote?id="+id+"&vote="+vote, function(data) {

		  that.wrapper.addClass('hotNot__wrapper--active')

		  that.results.removeClass('hotNot__result--active')
		  that.results[index].addClass('hotNot__result--active')

		  that.percents[0].innerHTML = data.hot + '%'
		  that.percents[1].innerHTML = data.not + '%'

          that.count.innerHTML = parseInt(that.count.innerHTML) + 1

          setCookie('hnt_' + id, '1', 1)

	  });

  }

}
